import React from 'react';
import './Legal.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="legal-container">
      <div className="legal-card">
        <div className="legal-header">
          <h1>Privacy Policy</h1>
          <p className="legal-updated">Last Updated: March 27, 2026</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Introduction</h2>
            <p>
              ASL Information Services ("we", "our", "Sermyble") is committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
              when you use the Sermyble platform.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Information We Collect</h2>
            <h3>2.1 Personal Information</h3>
            <ul>
              <li>Full name and contact details (email, phone number)</li>
              <li>Business name and address</li>
              <li>PAN number and PAN card document</li>
              <li>GSTIN and GST certificate</li>
              <li>FSSAI license number and document</li>
              <li>Bank account details (account number, IFSC, beneficiary name)</li>
              <li>Google account information (when signing in with Google)</li>
            </ul>

            <h3>2.2 Automatically Collected Information</h3>
            <ul>
              <li>Device information (browser type, operating system)</li>
              <li>IP address and approximate location</li>
              <li>Usage data (pages visited, time spent, actions taken)</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. How We Use Your Information</h2>
            <ul>
              <li>Process and verify your partner registration</li>
              <li>Verify identity and compliance documents</li>
              <li>Facilitate payment settlements to your bank account</li>
              <li>Send order notifications via SMS and WhatsApp</li>
              <li>Provide customer support and respond to inquiries</li>
              <li>Improve our platform and services</li>
              <li>Comply with legal obligations (GST filing, tax reporting)</li>
              <li>Prevent fraud and ensure platform security</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Information Sharing</h2>
            <p>We may share your information with:</p>
            <ul>
              <li><strong>Customers</strong> — Your food court name, menu, and operating hours are displayed publicly</li>
              <li><strong>Payment Processors</strong> — Bank details for settlement processing</li>
              <li><strong>SMS/WhatsApp Providers</strong> — Phone numbers for notifications (MSG91)</li>
              <li><strong>Government Authorities</strong> — When required by law (tax authorities, FSSAI)</li>
              <li><strong>Cloud Service Providers</strong> — For data storage and processing</li>
            </ul>
            <p className="legal-note">
              We do not sell your personal information to third parties for marketing purposes.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Data Security</h2>
            <p>We implement industry-standard security measures including:</p>
            <ul>
              <li>SSL/TLS encryption for all data in transit</li>
              <li>Encrypted storage for sensitive documents</li>
              <li>JWT-based authentication with token expiry</li>
              <li>OTP verification for account access</li>
              <li>Rate limiting to prevent abuse</li>
              <li>Regular security audits and monitoring</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Data Retention</h2>
            <p>
              We retain your personal information for as long as your account is active or as needed to 
              provide services. After account termination, we retain data for up to <strong>3 years</strong> to 
              comply with legal, accounting, and regulatory requirements.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li><strong>Access</strong> — Request a copy of your personal data</li>
              <li><strong>Correction</strong> — Request correction of inaccurate data</li>
              <li><strong>Deletion</strong> — Request deletion of your data (subject to legal requirements)</li>
              <li><strong>Portability</strong> — Receive your data in a structured, machine-readable format</li>
              <li><strong>Withdraw Consent</strong> — Opt out of marketing communications</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>8. Cookies</h2>
            <p>
              We use cookies and localStorage to save your registration progress, remember your preferences, 
              and improve your experience. You can control cookies through your browser settings, but 
              disabling them may affect platform functionality.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Children's Privacy</h2>
            <p>
              Our Platform is not intended for individuals under 18 years of age. We do not knowingly 
              collect personal information from children.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of significant changes 
              via email or through a notice on the Platform. Your continued use of the Platform after changes 
              constitutes acceptance of the updated policy.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Contact Us</h2>
            <p>For privacy-related questions or to exercise your rights, contact us at:</p>
            <div className="legal-contact">
              <p><strong>ASL Information Services — Data Protection</strong></p>
              <p>Email: <a href="mailto:info@aslinformationservices.com">info@aslinformationservices.com</a></p>
              <p>Phone: <a href="tel:+917093281075">+91 70932 81075</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
